import React, { useContext } from "react";
import { RadioButtonLabel, RadioButtons, WhiteContainer } from "../../../../../styles/orderform.tsx";
import { OrderContext } from "../../OrderContext.tsx";
import { customerTypes } from "../../data.ts";
import { useTranslation } from "react-i18next";

function CustomerType() {
  const { formValues, handleFormChange } = useContext(OrderContext);
  const { t } = useTranslation();

  return (
    <WhiteContainer>
      <h2>{t('phaseOne.choose')}</h2>

      <RadioButtons>
        {customerTypes.map((option) => (
          <label key={option.value} className="radio-label">
            <input 
              name="customer-type"
              type="radio"
              value={option.value}
              checked={formValues['customer-type'] === option.value}
              onChange={handleFormChange}
            />
            <div className="image-container">
              <img src={option.img} alt={option.imgAlt} />
            </div>
            {t(option.label)}
          </label>
        ))}
      </RadioButtons>

    </WhiteContainer>
  );
}

export default CustomerType;